import React from 'react';
import { Box } from '@rsos/components/capstone/base';
import {
  BaseInfoWindowWarningText,
  InfoWindowWarningSubtext,
  InlineText,
} from './InfoWindow.styles';

export const InfoWindowWarning = () => {
  return (
    <Box pt={2}>
      <BaseInfoWindowWarningText>
        <InlineText>WARNING: </InlineText>
        Clicking “Access Building” will notify 911inform subscribers
      </BaseInfoWindowWarningText>
      <InfoWindowWarningSubtext>
        (eg. on-site security, etc.)
      </InfoWindowWarningSubtext>
    </Box>
  );
};
